import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import { getLatestConversationsRequest } from "@microdoing/shared/services/message/actions";
import { useEffect } from "react";
import { Box, MainText, PressableOpacity } from "app/components/common";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import MessageBox from "app/components/common/Box/IconBox/MessageBox";
import MultipleAvatars from "../CurrentTrackScreen/TeamScreen/MultipleAvatars";
import { useNavigation } from "@react-navigation/native";
import i18n from "@microdoing/shared/i18n";

interface IReviewChat {
  review: {
    validationComment: string;
    comments: [
      {
        text: string;
        isSeen: boolean;
        createdAt: Date;
        user: {
          _id: string;
          avatar: string;
          name: string;
        };
      },
    ];
    corrector: {
      name: string;
      picture: string;
      correctorId: string;
    };
  };
  stepFeedbackId: string;
}

const ReviewChat = ({ review, stepFeedbackId }: IReviewChat) => {
  const [notificationNotSeen, setNotificationNumber] = useState(0);

  const userId = useSelector(getUserId);

  const { corrector } = review;

  const dispatch = useDispatch();
  const navigation = useNavigation();

  useEffect(() => {
    dispatch(getLatestConversationsRequest({ userId }));
  }, []);

  useEffect(() => {
    setNotificationNumber(
      review.comments?.filter(com => !com.isSeen && com?.user?._id !== userId)
        ?.length || 0,
    );
  }, [review.comments, userId]);

  const openChatScreen = () => {
    const { comments } = review;

    if (!!corrector) {
      navigation.navigate("ReviewChatScreen", {
        comments,
        corrector,
        stepFeedbackId,
      });
    }
  };

  return (
    <PressableOpacity onPress={openChatScreen}>
      <Box
        flexDirection="row"
        backgroundColor="neutral.white"
        borderRadius={10}
        borderWidth={1}
        borderColor="neutral.100"
        paddingHorizontal="sm"
        paddingVertical="sm"
        justifyContent="space-between"
      >
        <Box alignItems="flex-start" justifyContent="center">
          {corrector && <MainText variant="l4-bold">{corrector.name}</MainText>}
          <MainText variant="l3-regular" color="neutral.600">
            {corrector ? i18n.t("corrector") : i18n.t("no-corrector-yet")}
          </MainText>
        </Box>
        <Box flexDirection="row" alignItems="center">
          {!!corrector && (
            <Box marginRight="sm">
              <MultipleAvatars
                maxNumberOfAvatars={3}
                avatars={[corrector]}
                size={normalize(40)}
              />
            </Box>
          )}
          <MessageBox
            width={normalize(40)}
            height={normalize(40)}
            backgroundColor={corrector ? "brand.500" : "neutral.600"}
            iconColor={theme.colors["neutral.white"]}
            borderRadius={normalize(20)}
          />
          {notificationNotSeen !== 0 && (
            <Box
              height={normalize(15)}
              width={normalize(15)}
              borderRadius={normalize(10)}
              borderWidth={2}
              borderColor="neutral.white"
              alignItems="center"
              justifyContent="center"
              backgroundColor="system.red.900"
              position="absolute"
              top={normalize(1)}
              right={normalize(-5)}
              zIndex={3}
            />
          )}
        </Box>
      </Box>
    </PressableOpacity>
  );
};

export default ReviewChat;
